export const HfdiBlogStatus = {
  DRAFT: "draft",
  PUBLISHED: "published",
  PENDING_REVIEW: "pending_review",
  FUTURE: "future",
  AUTO_DRAFT: "auto_draft",
};
